<script setup lang="ts">
import type { IProps } from './career-wideCtaBox.types'

defineProps<IProps>()
const { isTablet } = useBSBreakpoints()

const setBackground = (desktopImage: Record<any, any>, mobileImage: Record<any, any>) => {
  return {
    backgroundImage: `url(${isTablet.value ? desktopImage.url : mobileImage.url})`,
  }
}

</script>

<template>
  <ClientOnly>
    <div
      :style="setBackground(desktopBackgroundImage[0], mobileBackgroundImage[0])"
      class="ui-cta-wide-box"
    >
      <h5 class="ui-cta-wide-box__title">
        {{ title }}
      </h5>

      <UiButton
        v-if="button"
        v-bind="{...button}"
        class="ui-cta-wide-box__button"
      >
        {{ button.label }}
      </UiButton>
    </div>
  </ClientOnly>
</template>

<style lang="scss" scoped>
.ui-cta-wide-box {
  margin-right: -25px;
  margin-left: -25px;
  padding: 8rem 0;
  background-repeat: no-repeat;
  background-size: 100%;
  border-radius: 1.6rem;

  &__title {
    @include h8;
    color: $text-400;
    text-align: center;
  }

  &__button {
    margin: auto;
    margin-top: 3rem;
  }

  @include atXS {
    margin-right: 0;
    margin-left: 0;
    padding: 12rem 0;
    background-size: cover;

    &__title {
      @include h3;
    }

    &__button {
      margin-top: 4.8rem;
    }
  }
}
</style>
